<div class="search-section">
  <div class="tab-container">
    <div class="tab" [ngClass]="{'activate':!search_tab}" (click)="search_tab = keepOneOpen(search_tab)">検索</div>
    <div class="tab" [ngClass]="{'activate':!tag_tab}" (click)="tag_tab = keepOneOpen(tag_tab)">クイック</div>
  </div>
  <app-search [searchSide]="searchSide" [searchService]="searchService" [searchParams]="searchParams" [id]="id" (searching)="searching.emit()" (searchFinish)="searchFinish.emit()" [page]="page" [open]="search_tab"></app-search>
  <app-search-tag-list [searchParams]="searchParams" [searchSide]="searchSide" [searchService]="searchService" [page]="page" [open]="tag_tab"></app-search-tag-list>
  <div class="tab-container">
    <div class="tab search-section-csv-download-button" (click)="mailIndexDownloadCSV()">
      CSVダウンロード
      <div><i class="fa fa-download"></i></div></div>
  </div>
</div>
